import { useDispatch } from 'react-redux';
import { setBreadCrumbsData } from '../../../store/redux/breadCrumbsData';
import { useTranslation } from 'react-i18next';
import CreateAccessoryForm from '../../../modules/accessories/components/CreateAccessoryForm';
import { useParams } from 'react-router-dom';

const CreateAccessory = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { id } = useParams();
  const title = id ? t('edit_accessory') : t('create_accessory');
  dispatch(
    setBreadCrumbsData({
      links: [{ label: title, path: '/accessories/create-accessory' }],
      page_title: title
    })
  );

  return (
    <div>
      <CreateAccessoryForm />
    </div>
  );
};

export default CreateAccessory;
